<div class="ei-container" [formGroup]="form" *ngIf="form" [ngClass]="{'editing': editing, 'not-editing': !editing}">
  <ng-container *ngIf="!readonly && editing else noEditingPanel">
    <input class="form-control" [type]="inputType" [formControlName]="control" [placeholder]="placeholder" [readonly]="!editing" #editingField />
    <button class="button m dark" (click)="toggleEdit()">
      <i class="bi bi-check2"></i>
    </button>
  </ng-container>
  <ng-template #noEditingPanel>
    <div class="form-read-only-control">
      <span>{{ form.get(control)?.value | na }}</span>
    </div>
    <button class="button m dark" *ngIf="!readonly else readonlyLock" (click)="toggleEdit()">
      <i class="bi bi-pencil"></i>
    </button>
    <ng-template #readonlyLock>
        <span class="lock-icon">
          <i class="bi bi-lock-fill"></i>
        </span>
    </ng-template>
  </ng-template>
</div>
